// extracted by mini-css-extract-plugin
export default {"paymentSection":"S1-z","disabled":"T1-z"};